import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import './index.less';

export default (props) => {
  const {
    visible,
    toCreateLeft,
    toCreateRight,
    title = '我是title',
    leftbg = '//img30.360buyimg.com/pop/jfs/t1/192572/34/20175/98220/6128a54aE889cce62/ef910b088876cd76.png',
    rightbg = '//img30.360buyimg.com/pop/jfs/t1/197141/21/5086/92109/6128a909E13ac53eb/207a2fd6a8d67afe.png',
    tipsinfo = '我是提示',
    left = '',
    right = '',
    onCancel = () => {},
  } = props;

  return (
    <Modal
      title={title}
      visible={visible}
      footer={null}
      width={555}
      onCancel={onCancel}
      className="activity-type-modal"
    >
      <div className="create-modal-type-tips">
        <InfoCircleFilled />
        {tipsinfo}
      </div>
      <div className="create-modal-type-body">
        <div
          className="create-modal-left-card"
          style={{ background: ' url(' + leftbg + ')', backgroundSize: 'cover' }}
          onClick={toCreateLeft}
        >
          {left}
        </div>

        <div
          className="create-modal-right-card"
          style={{ background: 'url(' + rightbg + ')', backgroundSize: 'cover' }}
          onClick={toCreateRight}
        >
          {right}
        </div>
      </div>
    </Modal>
  );
};
